<header>
  <fs-sidebar></fs-sidebar>
  <fs-tab-bar></fs-tab-bar>
</header>

<main>
  <router-outlet></router-outlet>
  <fs-footer></fs-footer>
</main>
